/**
 * Green Brothers — simple testimonial carousel.
 */
(() => {
  if (customElements.get('gb-quotes')) return;

  class GbQuotes extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-gb-quote]')];
      this.dots = [...this.querySelectorAll('[data-gb-quotes-dot]')];
      this.prev = this.querySelector('[data-gb-quotes-prev]');
      this.next = this.querySelector('[data-gb-quotes-next]');
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = 0;

      if (this.slides.length < 2) {
        this.querySelector('.gb-proof__controls')?.setAttribute('hidden', '');
        return;
      }

      this.prev?.addEventListener('click', () => this.go(this.index - 1));
      this.next?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i));
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => {
        if (!this.contains(document.activeElement)) this.play();
      });

      this.go(this.index, true);
      this.play();
    }

    disconnectedCallback() {
      this.stop();
    }

    play() {
      this.stop();
      if (this.reduce || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), 6400);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = 0;
    }

    go(next, instant) {
      const total = this.slides.length;
      if (!total) return;
      this.index = ((next % total) + total) % total;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const on = i === this.index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });

      if (!instant) this.play();
    }
  }

  customElements.define('gb-quotes', GbQuotes);
})();
